import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionAutomationService } from '../services/automation.service';
import type { AutomationRule } from '../types/automation.types';
import { toast } from 'sonner';

export function useConstructionAutomation(companyId: string, projectId?: string) {
  const queryClient = useQueryClient();

  const rulesQuery = useQuery({
    queryKey: ['construction-automation-rules', companyId, projectId],
    queryFn: () => ConstructionAutomationService.getRules(companyId, projectId),
    enabled: !!companyId,
  });

  const toggleMutation = useMutation({
    mutationFn: ({ id, isEnabled }: { id: string; isEnabled: boolean }) => 
      ConstructionAutomationService.toggleRule(id, isEnabled),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-automation-rules'] });
      toast.success('Đã cập nhật trạng thái quy tắc');
    },
    onError: (error: any) => {
      toast.error('Lỗi: ' + error.message);
    }
  });

  const logsQuery = useQuery({
    queryKey: ['construction-automation-logs', companyId],
    queryFn: () => ConstructionAutomationService.getLogs(companyId),
    enabled: !!companyId,
  });

  return {
    rules: rulesQuery.data || [],
    logs: logsQuery.data || [],
    isLoading: rulesQuery.isLoading || logsQuery.isLoading,
    toggleRule: toggleMutation.mutateAsync,
    isToggling: toggleMutation.isPending
  };
}
